import React from 'react';
import { FormattedNumber } from 'react-intl';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../CMSEventTournament.scss';

export interface SeatDraw {
  position: string;
  name: string;
  seat: string;
  chips: number;
}

export interface SeatDrawData {
  seatDraw: SeatDraw[];
}

const SeatDrawTable: React.FC<SeatDrawData> = ({ seatDraw }) => (
  <div className={styles.tableContainer}>
    <table className={styles.eventsTable}>
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Seat</th>
          <th>Chips</th>
        </tr>
      </thead>
      <tbody>
        {seatDraw.map((item, index) => (
          <tr key={index} className={styles.textCenter}>
            <td>{item.position}</td>
            <td>{item.name}</td>
            <td>{item.seat}</td>
            <td>
              <FormattedNumber style="decimal" value={item.chips} />
            </td>
          </tr>
        ))}
        {!seatDraw.length && (
          <tr>
            <td className={styles.textCenter} colSpan={4}>
              No Data
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default SeatDrawTable;
